import React, { useEffect, useState } from "react";
import { environment } from "environment/environment";
import "./Subscribe.css";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../common/AuthContext";
import { SubscribeModel } from "./SubscribeModel";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const Subscribe = () => {
  // const { user, logout, isLoading } = useAuth();
  const { user,  userPlan, setUserPlan,isLoading } = useAuth();
  const navigate = useNavigate();

  const [allPlanDetails, setAllPlanDetails] = useState([]);
const [subscribingPlanId, setSubscribingPlanId] = useState(null);
  // ✅ Redirect to login if not logged in
  useEffect(() => {
    if (!isLoading && !user) {
      navigate("/login");
    }
  }, [user, isLoading, navigate]);

  // ✅ Fetch user plan & all plan details
  useEffect(() => {
  
    const fetchAllPlanDetails = async () => {
      try {
        const response = await fetch(
          `${environment.baseUrl}/plan-detail/get-all-plan-detail`,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              Accept: "application/json",
            },
          }
        );

        const res = await response.json();

        if (res.status && res.data) {
          setAllPlanDetails(res.data);
          console.log("Fetched allPlanDetails => ", res.data);
        }
      } catch (error) {
        console.error("Error fetching all plan details:", error);
        toast.error("Error fetching plan details!");
      }
    };


    fetchAllPlanDetails();
  }, [user]);

  // ✅ Subscribe click handler
  const handleSubscribe = async (plan) => {
    if (!user?.userId) {
      toast.warn("Please login to subscribe.");
      navigate("/login");
      return;
    }
    // 🔥 ADD: lock only this plan
    setSubscribingPlanId(plan.id);

    // Create a SubscribeModel instance
    const subscribeData = new SubscribeModel(
      0, // id (new subscription)
      user.userId, // userId
      plan.plan, // planName
      plan.id, // planDetailId
      plan.planValidity // planValidity
    );

    console.log("Captured SubscribeModel =>", subscribeData);

    try {
      const response = await fetch(`${environment.baseUrl}/user-pan/save-user-plan`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(subscribeData),
      });

      const res = await response.json();

      if (res.status && res.data) {
        setUserPlan(res.data); // Update user plan in context
        toast.success(res.message, {
          autoClose: 1500,
          onClose: () => navigate("/nse-option-chain"),
        });
        

        console.log("Subscription response:", res.data);

      } else {
        setSubscribingPlanId(null);
        toast.error(res.message || "Subscription failed. Try again.");
      }
    } catch (error) {
      setSubscribingPlanId(null);
      console.error("Error subscribing:", error);
      toast.error("Error occurred while subscribing.");
    }
  };

  // const handleLogout = () => {
  //   logout();
  //   navigate("/login");
  // };

  if (isLoading) return <div className="loading">Loading...</div>;
  if (!user) return null;

  return (
    <div className="subscribe-container">
      <div className="welcome-banner fade-in">
        <div>
          <h2 className="welcome-title">
            Welcome back, {user?.userName || "User"}!
          </h2>
          <p className="welcome-text">
            Ready to continue your journey? Let’s see what’s new today.
          </p>
        </div>
      </div>

      <div className="info-card-top">
        <section className="card">
          <h2>User Details</h2>
          <div className="detail-row">
            <span className="label">User ID:</span>
            <span className="value">{user?.userId || "--"}</span>
          </div>
          <div className="detail-row">
            <span className="label">Name:</span>
            <span className="value">{user?.userName || "--"}</span>
          </div>
          <div className="detail-row">
            <span className="label">Mobile:</span>
            <span className="value">{user?.mobileNumber || "--"}</span>
          </div>
          <div className="detail-row">
            <span className="label">Email:</span>
            <span className="value">{user?.email || "--"}</span>
          </div>
          <div className="detail-row">
            <span className="label">Post:</span>
            <span className="value">Admin</span>
          </div>
        </section>

        <section className="card">
          <h2>Plan & Validity</h2>
          <div className="detail-row">
            <span className="label">Plan:</span>
            <span className="value">
              {userPlan?.planName || "--"} ₹
              {userPlan?.planAmount ?? "N/A"}
            </span>
          </div>
          <div className="detail-row">
            <span className="label">Plan Validity</span>
            <span className="value">
              {userPlan?.planValidity || "--"} ₹
            </span>
          </div>
          <div className="detail-row">
            <span className="label">Days Left:</span>
            <span className="value">
              {userPlan?.daysLeft || "--"}
            </span>
          </div>
          <div className="detail-row">
            <span className="label">Start:</span>
            <span className="value">
              {userPlan?.subscribeDateStart || "--"}
            </span>
          </div>
          <div className="detail-row">
            <span className="label">End:</span>
            <span className="value">
              {userPlan?.subscribeDateEnd || "--"}
            </span>
          </div>
        </section>

        <section className="card">
          <h2>Performance</h2>
          <div className="detail-row">
            <span className="label">Total Trades:</span>
            <span className="value">248</span>
          </div>
          <div className="detail-row">
            <span className="label">Win Rate:</span>
            <span className="value">78%</span>
          </div>
          <div className="detail-row">
            <span className="label">Profit:</span>
            <span className="value">₹1,24,500</span>
          </div>
        </section>
      </div>

      {/* ================== Bottom Info Cards row ================== */}
      {/* ================== Bottom Info Cards row ================== */}
      <div className="info-card-bottom">
        {allPlanDetails && allPlanDetails.length > 0 ? (
          allPlanDetails.map((plan, index) => {
            const isLoadingThisPlan = subscribingPlanId === plan.id;

            return (
              <section key={index} className="card card-mouse-over plan-card">
                <div className="plan-header">
                  <h2>
                    {plan.plan ?? "N/A"} ₹{plan.amount ?? "N/A"}
                  </h2>
                </div>

                <div className="detail-row">
                  <span>✔ FREE Live Option Chain</span>
                </div>
                <div className="detail-row">
                  <span>✔ Historical Data</span>
                </div>
                <div className="detail-row">
                  <span>✔ Live Class (Sunday)</span>
                </div>
                <div className="detail-row">
                  <span>✔ Recorded Class</span>
                </div>
                <div className="detail-row">
                  <strong>✔ {plan?.planValidity ?? "N/A"} days Validity</strong>
                </div>

                <div className="button-container">
                  <button
                    className="subscribe-button d-flex justify-content-center align-items-center"
                    type="button"
                    disabled={isLoadingThisPlan}
                    onClick={() => handleSubscribe(plan)}
                  >
                    {isLoadingThisPlan ? (
                      <>
                        <span className="spinner-border spinner-border-sm me-2" />
                        Subscribing...
                      </>
                    ) : (
                      "Subscribe Now"
                    )}
                  </button>
                </div>
              </section>
            );
          })
        ) : (
          <div>No plan details available.</div>
        )}
      </div>

      {/* ✅ Toast container for notifications */}
      <ToastContainer position="top-center" autoClose={3000} hideProgressBar={false} />
    </div>
  );
};

export default Subscribe;
